module.exports = __webpack_public_path__ + "img/selected0-min.6716def5.png";